import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSalaryActivityPerformanceBillListDataApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSalaryActivityPerformanceBillListDataApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveSalaryActivityPerformanceBillApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteSalaryActivityPerformanceBillApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/delete',
    method: 'post',
    data
  })
}

// 发布
export function publishSalaryActivityPerformanceBillApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/publish',
    method: 'post',
    data
  })
}

// 撤回
export function backSalaryActivityPerformanceBillApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/back',
    method: 'post',
    data
  })
}

// 查看
export function viewSalaryActivityPerformanceBillApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/view',
    method: 'post',
    data
  })
}

// 根据主键查询人员统计
export function findSummaryInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/findSummaryInfoById',
    method: 'post',
    data
  })
}

// 导出根据主键查询人员统计
export function exportSummaryInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/exportSummaryInfoById',
    method: 'post',
    data
  })
}

// 导出根据主键查询人员明细
export function exportInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceBill/exportInfoById',
    method: 'post',
    data
  })
}